import React, { useState, useEffect } from "react";
import Sidebar from "@/components/Sidebar";
import Header from "@/components/Header";
import StatCard from "@/components/StatCard";
import OrdersSummary from "@/components/OrdersSummary";
import { Settings } from "lucide-react";
import { getDashboardStats } from "@/api/dashboard";

const Procurement = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [stats, setStats] = useState({
    totalRequests: 0,
    totalProducts: 0,
    totalSuppliers: 0,
    percentageChanges: {
      requests: "0%",
      products: "0%",
      suppliers: "0%",
    },
    latestRequests: [],
    latestSuppliers: [],
  });

  useEffect(() => {
    const fetchStats = async () => {
      const data = await getDashboardStats();
      setStats(data);
    };

    fetchStats();
  }, []);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onToggleSidebar={toggleSidebar} />

        <main className="flex-1 overflow-x-hidden overflow-y-auto p-4">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-800">
              Procurement Dashboard
            </h1>
            <p className="text-gray-600">
              Manage procurement requests and suppliers
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <StatCard
              type="orders"
              title="Total Requests"
              value={stats.totalRequests.toString()}
              percentage={stats.percentageChanges.requests}
            />
            <StatCard
              type="products"
              title="Total Products"
              value={stats.totalProducts.toString()}
              percentage={stats.percentageChanges.products}
            />
            <StatCard
              type="revenue"
              title="Total Suppliers"
              value={stats.totalSuppliers.toString()}
              percentage={stats.percentageChanges.suppliers}
            />
          </div>

          <div className="mb-6">
            <OrdersSummary />
          </div>

          <div className="grid grid-cols-1 gap-4 mb-6">
            <div className="bg-white rounded-lg shadow p-6">
              <h2 className="text-lg font-semibold mb-4">
                Active Procurement Tasks
              </h2>
              <div className="space-y-4">
                <div className="p-4 border border-gray-200 rounded-lg">
                  <h3 className="font-medium">
                    Review pending purchase orders
                  </h3>
                  <p className="text-sm text-gray-500 mt-1">
                    5 purchase orders require your approval
                  </p>
                </div>
                <div className="p-4 border border-gray-200 rounded-lg">
                  <h3 className="font-medium">Contact new suppliers</h3>
                  <p className="text-sm text-gray-500 mt-1">
                    3 new supplier applications pending review
                  </p>
                </div>
                <div className="p-4 border border-gray-200 rounded-lg">
                  <h3 className="font-medium">Update inventory levels</h3>
                  <p className="text-sm text-gray-500 mt-1">
                    Inventory audit required for 2 sites
                  </p>
                </div>
              </div>
            </div>
          </div>
        </main>

        <footer className="bg-white p-4 text-center text-gray-500 text-sm border-t">
          Copyright © 2021. All right reserved.
        </footer>
      </div>

      <div className="fixed bottom-4 right-4">
        <button className="bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-colors">
          <Settings size={24} />
        </button>
      </div>
    </div>
  );
};

export default Procurement;
